
























































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { GEnum } from '@/constants/enum.defination';
import { studentModule } from '@/store/modules/entities/student.module';
import { TrendComparison, TrendResult } from '@/models/student/student-trends';
import GStudentRecordTrendScoreTransition from '@/views/GStudentRecord/GStudentRecordTrendScoreTransition.vue';
import GOptionalData from '@/components/GOptionalData.vue';

@Component({
  name: 'GStudentRecordTrends',
  components: { GStudentRecordTrendScoreTransition, GOptionalData },
  computed: {},
  methods: {},
})
export default class GStudentRecordTrends extends mixins(GPageBase) {
  @Prop() studentID: number;

  async mounted() {
    await studentModule.fetchStudentTrends(this.studentID);
  }

  get isDisplayTrend(): boolean {
    // 追加サービスプランに傾向チェックが含まれている場合、表示する
    return this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademic);
  }

  get studentTrendsLatestResults(): TrendResult[] {
    return studentModule.studentTrends.latestResults;
  }

  get studentTrendsComparisonResults(): TrendComparison[] {
    return studentModule.studentTrends.comparisonResults;
  }

  get trendEchartService() {
    return studentModule.trendEchartService;
  }
}
